import { ReactNode } from "react";

import { Breadcrumbs, BreadcrumbsHome, BreadcrumbsLabel } from "@impero-com/ui";
import { Link } from "react-router-dom";

import { BreadcrumbSpec } from "../../componentTypes/breadcrumb";

export interface HeaderTitleProps {
    title: string | BreadcrumbSpec;
    rootPath: string;
    newMenu?: boolean;
}
export const HeaderTitle = ({ title, rootPath, newMenu }: HeaderTitleProps) => {
    const isStringTitle = typeof title === "string";
    const pageTitle = isStringTitle ? title : title.title;
    const ancestors = isStringTitle ? [] : title.breadCrumbs;

    return (
        <Breadcrumbs>
            {!newMenu && <BreadcrumbsHome href={rootPath} />}
            {ancestors.map((breadcrumb, i) => (
                <BreadcrumbLink
                    key={i}
                    url={breadcrumb.url}
                    href={breadcrumb.href}
                >
                    <BreadcrumbsLabel>{breadcrumb.label}</BreadcrumbsLabel>
                </BreadcrumbLink>
            ))}
            <BreadcrumbsLabel current>{pageTitle}</BreadcrumbsLabel>
        </Breadcrumbs>
    );
};

interface BreadcrumbLinkProps {
    url?: string;
    href?: string;
    children: ReactNode;
}

function BreadcrumbLink({ url, href, children }: BreadcrumbLinkProps) {
    return url ? (
        <Link to={url}>{children}</Link>
    ) : (
        <a href={href}>{children}</a>
    );
}
